var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-block" }, [
    _c("div", { staticClass: "event-dates" }, [
      _c("div", { staticClass: "event-date" }, [
        _vm._v(_vm._s(_vm.isoDate(_vm.event.raw_next_date, "MMM d")))
      ]),
      _vm._v(" "),
      _vm.event.dates.length > 1
        ? _c("div", { staticClass: "event-date-separator" }, [_vm._v("TO")])
        : _vm._e(),
      _vm._v(" "),
      _vm.event.dates.length > 1
        ? _c("div", { staticClass: "event-date" }, [
            _vm._v(_vm._s(_vm.lastIsoDate(_vm.event, "MMM d")))
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "event-image",
        attrs: { href: "#/event/" + _vm.event.url_title }
      },
      [
        _c("img", {
          attrs: {
            src: "https://api.everwondr.com" + _vm.event.thumbnail,
            alt: _vm.event.name
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "event-body" }, [
      _c("a", { attrs: { href: "#/event/" + _vm.event.url_title } }, [
        _c("h3", { domProps: { innerHTML: _vm._s(_vm.event.name) } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "event-address" }, [
        _c(
          "div",
          { staticClass: "address-icon" },
          [_c("font-awesome-icon", { attrs: { icon: "map-marker-alt" } })],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "address-parts" }, [
          _c("a", {
            staticClass: "address-street",
            attrs: { href: _vm.event.venue_url },
            domProps: { innerHTML: _vm._s(_vm.event.venue_name) }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "address-locale" }, [
            _vm._v(_vm._s(_vm.event.city) + ", " + _vm._s(_vm.event.state))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ew-event-actions" }, [
      _vm.plannerExists
        ? _c(
            "a",
            {
              staticClass: "ew-add-to-planner",
              on: {
                click: function($event) {
                  return _vm.togglePlannerItinerary(_vm.event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "add-icon",
                  class: { added: _vm.inPlanner(_vm.event) }
                },
                [
                  _c("i", {
                    staticClass: "fas",
                    class: [_vm.inPlanner(_vm.event) ? "fa-minus" : "fa-plus"]
                  })
                ]
              )
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/Event.vue?vue&type=template&id=242c5a28&
// module id = 420
// module chunks = 0